import { EventEmitter, Injectable, Output } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class AllocationTabSetSelectionService {
  @Output() newValue = new EventEmitter<string>();

  setTabValue(value: string): void {
    this.newValue.emit(value);
  }
}
